import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dedafd38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-header" }
const _hoisted_2 = { class: "main-title" }
const _hoisted_3 = { class: "sub-title" }
const _hoisted_4 = { class: "icon-section" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "dx-icon dx-icon-close" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "grid-loading-pane"
}
const _hoisted_8 = {
  key: 2,
  class: "non-scrollable-content"
}

import { displayCancelConfirmationAlert } from "@/alerts/cancelConfirmationAlert";
import { ModalWidth } from "@/types/ui/modals/ModalWidth";
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import { InitializedEvent } from "devextreme/ui/popup";
import {
  PropType,
  computed,
  inject,
  onMounted,
  onUnmounted,
  ref,
  useSlots,
  watch,
} from "vue";
import { sizes, subscribe, unsubscribe } from "../../../utils/media-query";
import ScrollView from "../scroll-view.vue";
import { HelpNavigator } from "@/services/HelpNavigator";
import DxLoadIndicator from "devextreme-vue/load-indicator";
import { displayCancelConfirmationWarningAlert } from "@/alerts/cancelConfirmationWarningAlert";


export default /*#__PURE__*/_defineComponent({
  __name: 'modal-base',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * The title or heading associated with the component.
   * This is typically displayed at the top of the modal or component.
   * @type {string}
   * @required
   */
  title: {
    type: String,
    required: true,
  },
  /**
   * The width of the modal or component.
   * This can be a predefined size (e.g., Small, Medium, Large) or a custom value.
   * @type {string}
   * @default ModalWidth.Small
   */
  width: {
    type: String as PropType<ModalWidth>,
    default: ModalWidth.Small,
  },
  /**
   * The height of the modal or component.
   * This can be a fixed value (e.g., '500px') or 'auto' to adjust based on content.
   * @type {string}
   * @default 'auto'
   */
  height: {
    type: String,
    default: "auto",
  },
  /**
   * The maximum height of the modal or component.
   * This ensures the modal does not exceed a certain height.
   * @type {string}
   * @default '80vh'
   */
  maxHeight: {
    type: String,
    default: "80vh",
  },
  /**
   * Determines whether to show the Close Button.
   * @type {boolean}
   * @default true
   */
  showCloseButton: {
    type: Boolean,
    default: true,
  },
  /**
   * Determines whether the data is currently being saved.
   * This is often used to display a loading state during save operations.
   * @type {boolean}
   * @default false
   */
  saving: {
    type: Boolean,
    default: false,
  },
  /**
   * Determines whether to show a confirmation prompt when attempting to close the modal.
   * This is useful to prevent accidental closure when unsaved changes exist.
   * @type {boolean}
   * @default false
   */
  showCloseConfirmationPrompt: {
    type: Boolean,
    default: false,
  },
  /**
   * The color of the shading outside the modal.
   * This can be used to customize the background overlay.
   * @type {string}
   * @optional
   */
  outsideShadingColour: {
    type: String,
    default: "",
  },
  /**
   * Determines whether the scroll bar should automatically scroll to the bottom.
   * This is useful for content that updates dynamically.
   * @type {boolean}
   * @default false
   */
  scrollToBottom: {
    type: Boolean,
    default: false,
  },
  /**
   * Determines whether the content is currently loading.
   * This is often used to display a loading spinner or placeholder.
   * @type {boolean}
   * @default false
   */
  loadingContent: {
    type: Boolean,
    default: false,
  },
  /**
   * The CSS selector for the scrollable element within the modal.
   * This is used to control scrolling behavior for specific elements.
   * @type {string}
   * @optional
   */
  scrollableElementSelector: {
    type: String,
    default: "",
  },
  /**
   * The URL or path to the help page associated with the modal or component.
   * This can be used to provide additional guidance or documentation.
   * @type {string}
   * @optional
   */
  helpPage: {
    type: String,
    default: "",
  },
  /**
   * Custom text for the close confirmation prompt.
   * This allows for customization of the confirmation message.
   * @type {string}
   * @default 'Are you sure you want to cancel?'
   */
  customCloseConfirmationText: {
    type: String,
    default: "Are you sure you want to cancel?",
  },
  /**
   * Defines if the close confirmation should use warning behaviour instead of confirmation.
   * Allows for customisation of the close prompt.
   * @type {Boolean}
   * @default false
   */
  closeConfirmationIsWarning: {
    type: Boolean,
    default: false,
  },
},
  emits: [
  /**
   * Emitted when the `modelValue` is updated, syncing the modal's visibility state.
   * @param {boolean} value - The new visibility state of the modal.
   */
  "update:modelValue",

  /**
   * Emitted when the modal is about to close, before any confirmation.
   * Can be used to trigger actions such as cleanup or state updates.
   */
  "closingModal",

  /**
   * Emitted when the modal has been closed, after all close actions are completed.
   * Typically used to trigger any post-close logic, such as resetting state or triggering animations.
   */
  "modalClosed",

  /**
   * Emitted when the cancel confirmation prompt is denied by the user.
   * Used for handling the case where the user chooses not to close the modal.
   */
  "cancelPromptDenied",

  /**
   * Emitted when the cancel confirmation prompt is accepted by the user.
   * Indicates that the user confirmed they want to close the modal.
   */
  "cancelPromptAccepted",
  /**
   * Emitted when the close button (X) is clicked.
   */
  "xButtonClicked",
],
  setup(__props, { emit }) {

const props = __props;





const showPopup = computed({
  get: () => props.modelValue,
  set: (value: Boolean) => emit("update:modelValue", value),
});

watch(
  () => props.modelValue,
  () => {
    resetScrollPosition.value = !props.modelValue;
  },
);

onMounted(() => {
  subscribe(setPopupWidth);
  setPopupWidth();
});

onUnmounted(() => unsubscribe(setPopupWidth));

const popupWidth = ref(props.width);
const resetScrollPosition = ref(false);

const setPopupWidth = () => {
  const breakPoints = sizes();

  if (
    breakPoints["screen-x-small"] ||
    props.width === ModalWidth.MobileFullWidth
  ) {
    popupWidth.value = ModalWidth.XSmall;
    return;
  }

  switch (props.width) {
    case ModalWidth.XLarge:
      popupWidth.value = setXLargePopupWidth(breakPoints);
      return;
    case ModalWidth.Large:
      popupWidth.value = setLargePopupWidth(breakPoints);
      return;
    case ModalWidth.Medium:
      popupWidth.value = setMediumPopupWidth(breakPoints);
      return;
    case ModalWidth.Small:
      popupWidth.value = setSmallPopupWidth(breakPoints);
      return;
    default:
      popupWidth.value = ModalWidth.XSmall;
  }
};

const setXLargePopupWidth = (breakPoints: any) => {
  switch (true) {
    case breakPoints["screen-x-large"]:
      return ModalWidth.XLarge;
    case breakPoints["screen-large"]:
      return ModalWidth.Large;
    case breakPoints["screen-medium"]:
      return ModalWidth.Medium;
    case breakPoints["screen-small"]:
      return ModalWidth.Small;
    default:
      return ModalWidth.XSmall;
  }
};

const setLargePopupWidth = (breakPoints: any) => {
  switch (true) {
    case breakPoints["screen-x-large"]:
    case breakPoints["screen-large"]:
      return ModalWidth.Large;
    case breakPoints["screen-medium"]:
      return ModalWidth.Medium;
    case breakPoints["screen-small"]:
      return ModalWidth.Small;
    default:
      return ModalWidth.XSmall;
  }
};

const setMediumPopupWidth = (breakPoints: any) => {
  switch (true) {
    case breakPoints["screen-x-large"]:
    case breakPoints["screen-large"]:
    case breakPoints["screen-medium"]:
      return ModalWidth.Medium;
    case breakPoints["screen-small"]:
      return ModalWidth.Small;
    default:
      return ModalWidth.XSmall;
  }
};

const setSmallPopupWidth = (breakPoints: any) => {
  return breakPoints["screen-x-small"] ? ModalWidth.XSmall : ModalWidth.Small;
};

const onClosingModal = async (e: any) => {
  if (!props.showCloseConfirmationPrompt) {
    emit("closingModal");
    return;
  }

  // Stop infinite prompts by checking if the user has already confirmed cancel prompt
  if (userConfirmedCancel.value) {
    emit("closingModal");
    return;
  }

  // To prevent users accidentally cancelling and losing data, prompt user for confirmation before closing
  const alertResult = (
    props.closeConfirmationIsWarning
      ? displayCancelConfirmationWarningAlert(props.customCloseConfirmationText)
      : displayCancelConfirmationAlert(props.customCloseConfirmationText)
  ).then((result) => {
    if (result.isConfirmed) {
      emit("cancelPromptAccepted");
    } else {
      emit("cancelPromptDenied");
    }
    return !result.isConfirmed;
  });

  e.cancel = alertResult;
};

const userConfirmedCancel = ref(false);

const isContentSlotUsed = computed(() => {
  const slots = useSlots();
  return !!slots["content"];
});

// Stops the escape key being used to close the modal. This avoids changes being accidentally lost
const onInitialized = (e: InitializedEvent) => {
  e.component?.registerKeyHandler("escape", (arg: any) => {
    arg.stopPropagation();
  });
};

// Resets the user confirmed cancel variable so cancel prompt is displayed when user next cancels modal
const onShowing = () => (userConfirmedCancel.value = false);

// Handles the hidden event of the DxPopup
const onModalClosed = () => {
  emit("modalClosed");
};

const closeModal = () => {
  emit("xButtonClicked");
  showPopup.value = false;
};

const helpNavigator = inject("HelpNavigator") as HelpNavigator;

const onHelpClick = () => helpNavigator.LoadHelpTopicByPageName(props.helpPage);

const isFooterSlotUsed = computed(() => {
  const slots = useSlots();
  return !!slots["footer"];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DxPopup), {
    visible: showPopup.value,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((showPopup).value = $event)),
    "drag-enabled": false,
    "hide-on-outside-click": false,
    "show-close-button": __props.showCloseButton,
    "show-title": true,
    title: __props.title,
    "content-template": "content",
    width: popupWidth.value,
    height: props.height,
    "max-height": props.maxHeight,
    onHiding: onClosingModal,
    onInitialized: onInitialized,
    onShowing: onShowing,
    onHidden: onModalClosed,
    shadingColor: props.outsideShadingColour,
    titleTemplate: "custom-title"
  }, _createSlots({
    content: _withCtx(() => [
      (props.loadingContent)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_unref(DxLoadIndicator), {
              height: 50,
              width: 50
            })
          ]))
        : _createCommentVNode("", true),
      (isContentSlotUsed.value && !props.loadingContent)
        ? (_openBlock(), _createBlock(ScrollView, {
            key: 1,
            "reset-scroll": resetScrollPosition.value,
            "onUpdate:resetScroll": _cache[0] || (_cache[0] = ($event: any) => ((resetScrollPosition).value = $event)),
            "scroll-to-bottom": __props.scrollToBottom,
            "scrollable-element-selector": __props.scrollableElementSelector
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "content")
            ]),
            _: 3
          }, 8, ["reset-scroll", "scroll-to-bottom", "scrollable-element-selector"]))
        : _createCommentVNode("", true),
      (!props.loadingContent && !isContentSlotUsed.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _renderSlot(_ctx.$slots, "non-scrollable-content")
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      (isFooterSlotUsed.value)
        ? (_openBlock(), _createBlock(_unref(DxToolbarItem), {
            key: 0,
            widget: "dxLoadIndicator",
            toolbar: "bottom",
            location: "after",
            options: { visible: props.saving, width: 24, height: 24 }
          }, null, 8, ["options"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "footer")
    ]),
    _: 2
  }, [
    (!__props.title)
      ? {
          name: "custom-title",
          fn: _withCtx(() => [
            _createElementVNode("section", _hoisted_1, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_2, [
                  _renderSlot(_ctx.$slots, "main-title")
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _renderSlot(_ctx.$slots, "sub-title")
                ])
              ]),
              _createElementVNode("div", _hoisted_4, [
                (props.showCloseButton && !__props.title)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "close-button-holder",
                      onClick: closeModal
                    }, _hoisted_6))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          key: "0"
        }
      : {
          name: "custom-title",
          fn: _withCtx(() => [
            _createElementVNode("div", {
              class: "dx-toolbar dx-widget dx-visibility-change-handler dx-collection dx-popup-title dx-has-close-button custom-header",
              role: "toolbar"
            }, [
              _createElementVNode("div", { class: "dx-toolbar-items-container" }, [
                _createElementVNode("div", { class: "dx-toolbar-before" }, [
                  _createElementVNode("div", { class: "dx-item dx-toolbar-item dx-toolbar-label" }, [
                    _createElementVNode("div", { class: "dx-item-content dx-toolbar-item-content" }, [
                      _createElementVNode("div", { class: "main-title" }, _toDisplayString(__props.title), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "dx-toolbar-after" }, [
                  _createElementVNode("div", { class: "dx-item dx-toolbar-item dx-toolbar-button" }, [
                    _createElementVNode("div", { class: "dx-item-content dx-toolbar-item-content" }, [
                      (__props.helpPage)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "acq-icon-button dx-widget dx-button dx-button-mode-text dx-button-normal dx-button-has-icon",
                            role: "button",
                            "aria-label": "Help",
                            onClick: onHelpClick
                          }, [
                            _createElementVNode("div", { class: "dx-button-content" }, [
                              _createElementVNode("i", { class: "dx-icon far fa-question" }),
                              _createElementVNode("div", { class: "dx-inkripple" })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (__props.showCloseButton)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "acq-icon-button dx-widget dx-button dx-button-mode-text dx-button-normal dx-button-has-icon dx-closebutton",
                            role: "button",
                            "aria-label": "Close",
                            tabindex: "0",
                            onClick: closeModal
                          }, [
                            _createElementVNode("div", { class: "dx-button-content" }, [
                              _createElementVNode("i", { class: "dx-icon dx-icon-close" }),
                              _createElementVNode("div", { class: "dx-inkripple" })
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          key: "1"
        }
  ]), 1032, ["visible", "show-close-button", "title", "width", "height", "max-height", "shadingColor"]))
}
}

})